import { Canvas } from "fabric";
import type { BrushOptions } from "./BrushTool";
import type { TextOptions } from "./TextTool";
import type { TransformOptions } from "./TransformTool";

export type AvailableTool =
  | ITool<BrushOptions>
  | ITool<TextOptions>
  | ITool<TransformOptions>;

export type ToolOptions =
  | Partial<BrushOptions>
  | Partial<TextOptions>
  | Partial<TransformOptions>;

export interface ITool<
  T extends BrushOptions | TextOptions | TransformOptions,
> {
  deactivate: () => void;
  activate: (options?: Partial<T>) => void;
  updateOptions?: (options: Partial<T>) => void;
}

class Tool {
  constructor(protected canvas: Canvas | null) {}
}

export default Tool;
